module.exports = __webpack_public_path__ + "static/media/sllaser.221f6960.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/sllaser.png
// module id = 466
// module chunks = 0